import { AfterViewInit, Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { JwtHelperService } from '@auth0/angular-jwt';
import { Store } from '@ngrx/store';
import { FormsModule, NgForm } from '@angular/forms';
import { AuthService } from '../services';
import { AuthState, RestoreSession, SetPending } from '../store';
import { CLIENT_PORTAL_URL, PROD_TOKEN } from '../tokens/tokens';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Location, NgIf } from '@angular/common';
import { Auth } from '@angular/fire/auth';

@Component({
  selector: 'ls-login',
  templateUrl: './login.component.html',
  // styleUrls: ['./login.component.scss']
  styles: [`
        :host {
            flex: 1;
            display: flex;
            height: 100vh;
        }

        mat-card {
            margin: auto;
            width: 370px;
        }

        img {
            display: block;
            margin: auto;
        }

        form {
            display: flex;
            flex-direction: column;
        }

        .form-actions {
            display: flex;
            flex-direction: row;
            justify-content: center;
        }

        button.submit-btn {
            display: block;
            width: 100%;
        }

        .error-box {
            height: 20px;
            margin-bottom: 16px;
            color: red;
        }
    `],
  standalone: true,
  imports: [
    FormsModule,
    MatInputModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    NgIf
  ]
})
export class LoginComponent implements OnInit {
  username: string = '';
  password: string = '';
  loginFailed: boolean = false;

  constructor(
    // private auth2: LsAuthService,
    private auth: AuthService,
    private router: Router,
    private store: Store<AuthState>,
    @Inject(PROD_TOKEN) private prod: boolean,
    private snackbar: MatSnackBar,
    private route: ActivatedRoute,
    private fbAuth: Auth,
    @Inject(CLIENT_PORTAL_URL) private clientPortalURL: string,
    private location: Location
  ) { }

  login(form: NgForm): void {
    if (form.invalid)
      return;
    const snackbar = this.snackbar.open('Logging in...');
    this.store.dispatch(new SetPending());
    const username: string = this.username,
      password: string = this.password;

    this.auth.login(username, password, this.prod).subscribe(result => {
      this.store.dispatch(new RestoreSession());
      snackbar.dismiss();

      const queryParams = this.route.snapshot.queryParams;
      if (queryParams.return_url) {
        this.authenticateExternal(result.ls_jwt_token, queryParams.return_url);
      } else if (this.auth.redirectUrl) {
        this.router.navigateByUrl(this.auth.redirectUrl);
        this.auth.redirectUrl = null;
      } else {
        console.log('In here somehow?');
        
        this.router.navigate(['/clients']);
      }
    }, err => {
      console.log('LOGIN FAILED: ', err);
      if (err.error) {
        this.loginFailed = true;
      }
    })
  }

  authenticateExternal(token: string, returnUrl: string) {
    const redirectUrl = new URL(returnUrl);
    redirectUrl.searchParams.append('token', token);
    location.href = redirectUrl.toString();
  }

  ngOnInit(): void {
    const queryParams = this.route.snapshot.queryParams;
    if (this.auth.auth && queryParams.return_url) {
      this.authenticateExternal(this.auth.token, decodeURIComponent(queryParams.return_url));
    } else if (queryParams.token && this.auth.redirectUrl) {
      this.auth.externalLogin(queryParams.token);
      const nextUrl = new URL(`http://localhost:4200${this.auth.redirectUrl}`);
      nextUrl.searchParams.delete('token');
      console.log(nextUrl.pathname);
      this.store.dispatch(new RestoreSession());
      this.router.navigateByUrl(nextUrl.pathname);
    }

    // Authenticate automatically
    const queryParamsMap = this.route.snapshot.queryParamMap;
    setTimeout(() => {
      if (queryParamsMap.has('token')) {
        console.log('Have an external token');
        const token = queryParamsMap.get('token');
        this.auth.externalLogin(token)
        const redirectTarget = this.router.parseUrl(this.auth.redirectUrl);
        redirectTarget.queryParams = {};
        this.auth.redirectUrl = null;
        this.router.navigateByUrl(redirectTarget);
      } else if (this.auth.token) {
        console.log('I have the token!');
        this.router.navigate(['/']);
      } else {
        location.href = `${this.clientPortalURL}/login?return_url=${location.origin}${this.router.url}`;
      }
    }, 200);
  }

}
